<template>
  <v-form ref="form">
    <v-card>
      <v-card-title>
        {{ $t("addFundsToAuditPeriodForm.title", { year }) }}
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="minimalFunds"
          :label="$t('addFundsToAuditPeriodForm.minimalFunds.label')"
          type="number"
          min="0"
        ></v-text-field>

        <v-text-field
          v-model="stepModelFunds"
          :label="$t('addFundsToAuditPeriodForm.stepModelFunds.label')"
          type="number"
          min="0"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-btn :disabled="!valid" color="primary" class="mr-4" @click="create" :loading="loading">
          {{ $t("addFundsToAuditPeriodForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import { defaultTo } from "ramda";
import AddFundsToAuditPeriodMutation from "@/gql/mutations/AddFundsToAuditPeriodMutation.gql";

export default {
  props: {
    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      minimalFunds: null,
      stepModelFunds: null,
      year: new Date().getFullYear(),
      loading: false,
      saved: false,
    };
  },

  computed: {
    valid() {
      return defaultTo(0, this.stepModelFunds) + defaultTo(0, this.minimalFunds) > 0;
    },
  },

  methods: {
    async create() {
      this.loading = true;

      const minimalFunds = parseInt(defaultTo(0, this.minimalFunds));
      const stepModelFunds = parseInt(defaultTo(0, this.stepModelFunds));

      await this.$apollo.mutate({
        mutation: AddFundsToAuditPeriodMutation,
        variables: {
          id: this.auditPeriod.id,
          minimalFunds,
          stepModelFunds,
        },
      });

      this.$refs.form.reset();
      this.loading = false;
      this.saved = true;
    },
  },
};
</script>
